import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodReportSection from "./AbstractPeriodReportSection.js";

/**
 * Section used to render the list of keyfigures for a period report.
 */
export default class KeyfigureSection extends AbstractPeriodReportSection {
	getTitle() {
		return _("KPIs");
	}

	accept(visitor) {
		return visitor.visitKeyfigureSection(this);
	}

	static getType() {
		return "KeyfigureSection";
	}

	static getId() {
		return "kpis";
	}
}
